import { render } from "./TwoColumnList.vue?vue&type=template&id=b250d462"
import script from "./TwoColumnList.vue?vue&type=script&lang=js"
export * from "./TwoColumnList.vue?vue&type=script&lang=js"

import "./TwoColumnList.vue?vue&type=style&index=0&id=b250d462&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__